import React from 'react';
import {
  Icon,
  ShadowIcon,
  StickVideo,
  StickVideoBody,
  StickVideoHead,
  StickVideoIcons
} from '@components';
import { useMatchMedia } from '@utils';
import { breakpoints } from '@config';
import poster from './poster.webp';
import videoWebm from './video.webm';
import videoMpeg from './video.mp4';

const ForWhat: React.FC = () => {
  const match = useMatchMedia(breakpoints.pc);
  const iconSize = match ? 56 : 48;
  
  return (
    <StickVideo
      id={'for-what'}
      poster={poster}
      webm={videoWebm}
      mpeg={videoMpeg}
      shadow={`linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 9.82%, rgba(0, 0, 0, 0) 93.29%, #000000 100%),
                 linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 8.92%, rgba(0, 0, 0, 0) 82.65%, #000000 100%)`}
    >
      <StickVideoIcons>
        <ShadowIcon glyph={'app-1'} shadowColor={'rgba(255, 55, 98, 0.3)'} size={iconSize} />
        <ShadowIcon glyph={'app-2'} shadowColor={'rgba(255, 23, 117, 0.3)'} size={iconSize} />
        <ShadowIcon glyph={'app-3'} shadowColor={'rgba(44, 170, 148, 0.2)'} size={iconSize} />
        <Icon glyph={'app-4'} size={iconSize} />
      </StickVideoIcons>
      <StickVideoHead>
        Синтезируйте<br />
        аватаров с вашими<br />
        бизнес-механиками
      </StickVideoHead>
      <StickVideoBody>
        Например, в Звуке аватары играют на гитарах. Например, в Звуке аватары играют на гитарах
      </StickVideoBody>
    </StickVideo>
  );
};

export { ForWhat };
